import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Checkbox, FormControlLabel } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

interface Option {
  //id will be the used to identify this an option,
  // display name will be what is shown to the user
  id: string;
  displayName: string;
  disabled: boolean;
}

interface OptionSelectProps {
  /**
   * Single select tells whether the user is only allowed one selection
   * (or multiple if false)
   * Options is a list of options presented to the user
   * onChangeOptions is a function to set the selected options
   */
  singleSelect: boolean;
  defaultSelection: string[];
  options: Option[];
  onChangeOptions: Function;
}

const optionStyles = makeStyles((theme: Theme) =>
  createStyles({
    wizardOption: {
      padding: '1rem',
    },
    optionLabel: {},
    optionSelect: {},
    optionCheckbox: {},
    optionCheckboxContainer: {},
  }),
);



export default function OptionSelect({ singleSelect, options, onChangeOptions, defaultSelection }: OptionSelectProps) {
  /**
   * Creates a simple check box prompt for the user
   * and presents given options
   */
  const classes = optionStyles();
  const userPrompt = <h5>{singleSelect ? 'Select One' : 'Check all that apply'}</h5>;

  const optionsSelection =
    singleSelect ? (
      <div className={classes.wizardOption}>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={defaultSelection[0]}
            onChange={(e)=>{
              onChangeOptions([e.target.value]);
            }}
          >
            {options.map((opt, index) => (
              <FormControlLabel key={opt.id} value={opt.id} control={<Radio />} label={opt.displayName} />
            ))}
          </RadioGroup>
        </FormControl>
      </div>
    ) :
    options.map(
      //TODO make this MUI checkboxes
      (opt, index) => (
        <div key={opt.id} className={classes.wizardOption}>
          <FormControlLabel
            control={
              <Checkbox
                className={classes.optionCheckbox}
                id={opt.id}
                value={opt.id}
                checked={defaultSelection.includes(opt.id)}
                onChange={(e) => {
                  if(defaultSelection.includes(opt.id)){
                    // remove from default
                    let res = defaultSelection.filter((el:string)=> el !== opt.id);
                    onChangeOptions(res);
                  }else{
                    // add to default
                    let res = [...defaultSelection, opt.id]
                    onChangeOptions(res);
                  }
                }}
                disabled={opt.disabled}
              />
            }
            label={opt.displayName}
          />
        </div>
      ),
    );

  return (
    <div className={classes.optionSelect}>
      {userPrompt}
      <div className={classes.optionCheckboxContainer}>{optionsSelection}</div>
    </div>
  );
}
